import Skeleton from "../../../components/Skeleton/Skeleton";
import useScreenSize from "../../../hooks/useScreenSize";

const PageSkeleton = () => {
  const { isMobile } = useScreenSize();

  return (
    <div className="flex flex-col gap-4">
      {!isMobile && <Skeleton width="200px" height="40px" />}

      {Array.from({ length: 3 }).map((_, i) => (
        <div key={i} className="rounded-xl border border-[#EBEBEB] p-4">
          <Skeleton width="60px" height="24px" />
        </div>
      ))}
    </div>
  );
};

export default PageSkeleton;
